import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { PageAction } from '../../components/page-actions/page-actions.component';
import { CompositionService } from '@services/compositions/composition.service';
import { CompositionTypeService } from '@services/composition-types/composition-type.service';
import { DataTableComponent, DataTableEvent } from '../../components/data-table/data-table.component';
import { DialogService } from '@services/dialog/dialog.service';

@Component({
    selector: 'app-compositions',
    templateUrl: './compositions.component.html',
    styleUrls: ['./compositions.component.scss'],
    providers: [CompositionService, CompositionTypeService],
    standalone: false
})
export class CompositionsComponent implements OnInit {

  public title = 'Compositions';

  public params: any;

  public pageActions: PageAction[];

  public compositionType: any;

  public columns = [
    {
      prop: 'title',
    }
  ];

  @ViewChild(DataTableComponent) dataTable: DataTableComponent;

  public deadCompositions = [];

  constructor(
    public compositionService: CompositionService,
    public compositionTypeService: CompositionTypeService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private dialogService: DialogService,
  ) {
  }

  ngOnInit() {
    this.params = {
      typeId: this.activatedRoute.snapshot.params['id']
    };
    this.compositionTypeService.get(this.activatedRoute.snapshot.params['id']).then(data => {
      this.compositionType = data;
      this.title = 'Compositions of Type: ' + this.compositionType.title;
    });
    this.createPageActions();
    this.getDeadCompositions();
  }

  public onDetail(event: DataTableEvent): void {
    this.router.navigate(['compositions', event.row._id]);
  }

  public onEdit(event: DataTableEvent): void {
    this.router.navigate(['compositions', event.row._id, 'edit']);
  }

  public onCopy(event: DataTableEvent): void {
    this.router.navigate(['compositions', event.row._id, 'copy']);
  }

  public onRemove(event: DataTableEvent): void {
    this.dialogService
      .confirm('Remove composition?')
      .then(res => {
        if (!res) {
          return;
        }

        return this.compositionService.remove(event.row._id).then(() => {
          this.dataTable.refresh();
        }).catch(error => {
          const message = (error.error.message ? error.error.message : error.message);
          return this.dialogService.confirm(message, error.name);
        });
      });
  }

  public getDeadCompositions() {
    // This funcion is probably just useful because of an earlier error.
    // So there can not be any Compositions without typeId
    this.deadCompositions = [];
    this.compositionService.find(0, 100, {}).then(result => {
      result.data.map(entry => {
        if (!entry.typeId) {
          this.deadCompositions.push(entry);
        }
      });
    });
  }

  public removeDeadComposition(id) {
    this.compositionService.remove(id).then(() => {
      this.getDeadCompositions();
    });
  }

  private createPageActions(): void {
    this.pageActions = [
      new PageAction({
        icon: 'create_new_folder',
        title: 'Create new Composition',
        callback: () => {
          this.router.navigate(['compositions', 'create', this.compositionType._id]);
        }
      })
    ];
  }

}
